import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { faListAlt } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WishListCard } from "./WishListCard";
import { useDispatch, useSelector } from "react-redux";
import { getWishlist } from "../../services/wishlistService";
function WishList() {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const dispatch = useDispatch();
  const wishlistData = useSelector(
    (state) => state.wishlist?.getWishlist?.items
  );
  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        if (currentUser) {
          await getWishlist(dispatch, currentUser._id);
        }
      } catch (error) {
        console.error("Error fetching wishlist:", error);
      }
    };
    fetchWishlist();
  }, [dispatch, currentUser]);
  const isDiscountValid = (discount) => {
    if (!discount) return false;
    if (discount.status && discount.status !== "active") return false;
    if (discount.endDate && new Date(discount.endDate) < new Date())
      return false;
    if (
      typeof discount.usageLimit === "number" &&
      discount.usageLimit > 0 &&
      typeof discount.usage === "number" &&
      discount.usage >= discount.usageLimit
    ) {
      return false;
    }
    return true;
  };
  const courseData = wishlistData?.map((course) => {
    let finalPrice = course.price || 0;
    if (isDiscountValid(course.discountId)) {
      if (course.discountId.type === "fixedAmount") {
        finalPrice = Math.max(0, course.price - course.discountId.value);
      } else if (course.discountId.type === "percent") {
        finalPrice = Math.max(
          0,
          course.price * (1 - course.discountId.value / 100)
        );
      }
    }
    return {
      courseId: course._id,
      courseImage: course.thumbnail,
      courseName: course.title,
      rating: course.rating,
      enrolledCount: course.studentsEnrolled?.length || 0,
      price: `${finalPrice.toFixed(2)}`,
      oldPrice: isDiscountValid(course.discountId)
        ? `${course.price?.toFixed(2) || "0.00"}`
        : "",
    };
  });
  return (
    <>
      <div className="dropdown">
        <button
          className="btn btn-light rounded-circle icon-btn"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <img src="/icons/heart.png" className="icon" alt="" />
        </button>
        <ul
          className="dropdown-menu dropdown-menu-center"
          style={{ width: "376px" }}
          aria-labelledby="dropdownMenuButton1"
        >
          <div
            className="position-fixed bg-white p-2 px-3 border-3 border-bottom "
            style={{ width: "374px", zIndex: 1000 }}
          >
            <div className="d-flex align-items-center">
              <h5 className="text-start fw-bold mb-0">WishList</h5>
              <Link to={"/profile/wishlist"} className="ms-auto see-all-link">
                <p className="m-0 p-0">See all</p>
              </Link>
            </div>
          </div>
          <div>
            <div className="dropdown-container">
              {courseData?.length > 0 ? (
                courseData.map((course, index) => (
                  <WishListCard
                    key={index}
                    courseImage={course.courseImage}
                    courseName={course.courseName}
                    rating={course.rating}
                    enrolledCount={course.enrolledCount}
                    price={course.price}
                    oldPrice={course.oldPrice}
                    linkToCourseDetail={`/course/${course.courseId}`}
                  />
                ))
              ) : (
                <div className="text-muted text-center p-3">
                  <FontAwesomeIcon
                    icon={faListAlt}
                    style={{ fontSize: "24px" }}
                  />
                  <p className="mb-0 mt-2">Nothing in your wishlist yet</p>
                </div>
              )}
            </div>
          </div>
        </ul>
      </div>
    </>
  );
}

export default WishList;
